import React from 'react';
import { useLogout } from 'react-admin';

const MyLogoutButton = () => {
    const logout = useLogout();t

    return (
        <button onClick={logout}>
            Cerrar Sesión
        </button>
    );
};

export default MyLogoutButton;
